import React, { Component } from "react";

class PasswordEye extends Component {
  state = {
    Password: true
  };
  render() {
    const type = this.state.Password ? "password" : "text";
    return (
      <span className="password-eye">
        <input {...{ ...this.props, type }} />
        <i
          className={
            "icon omni-show-value" + (this.state.Password ? "" : "-open")
          }
          onClick={e => {
            e.stopPropagation();
            this.setState({ Password: !this.state.Password });
          }}
        />
      </span>
    );
  }
}

export default PasswordEye;
